// extracted by mini-css-extract-plugin
export default {"image":"dY-z","loaded":"eY-z"};